import React, { useRef, useState, useEffect } from "react";
import "../App.css";
import logo from "../images/shak7 logo final(2).png";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Header({ theme, toggleTheme, particlesEnabled, toggleParticles }) {
  const headerRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const goToSection = (id) => {
    setMenuOpen(false);

    if (location.pathname === "/") {
      const element = document.getElementById(id);
      if (element && window.smoother) {
        window.smoother.scrollTo(element, true, "top top");
      }
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  // Header shadow on scroll
  useEffect(() => {
    const header = headerRef.current;
    const handleScroll = () => {
      header.style.boxShadow = window.scrollY > 20 ? "0 4px 15px rgba(0,0,0,0.2)" : "none";
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="site-header" ref={headerRef}>
      <div className="wrap">
        <div className="logo">
          <img src={logo} width="180" alt="logo" />
        </div>

        <button className="burger" onClick={() => setMenuOpen(!menuOpen)}>☰</button>

        <nav className={`nav ${menuOpen ? "open" : ""}`}>
          <Link className="nav-link" to="/" onClick={() => setMenuOpen(false)}>Home</Link>
          <span className="nav-link" onClick={() => goToSection("vision")}>Vision & Mission</span>
          <span className="nav-link" onClick={() => goToSection("services")}>Services</span>
          <Link className="nav-link" to="/potfolio" onClick={() => setMenuOpen(false)}>potfolio</Link>
          <Link className="nav-link" to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</Link>
        </nav>
      </div>
    </header>
  );
}
